// extracted by mini-css-extract-plugin
export default {"portal-group-nav-wrapper":"PortalGroupNav_portal-group-nav-wrapper__HBiB7"};